import { HStack } from "@chakra-ui/react"
import CountCard from "../../../components/countCard/CountCard";


const UserCountSection = ({totalUsers = 0, totalDeleted = 0, totalRequested = 0}) => {
    return (
        <HStack justifyContent="flex-start" alignItems="center" mb={4} spacing={4}>
            <CountCard text="Total Admins" count={totalUsers} />
        </HStack>
    )
}
export default UserCountSection;